export const attendanceConstants = {
  ATTENDANCEBATCH: 'ATTENDANCE_BATCH',
  ATTENDANCESELECTEDDATE: 'ATTENDANCE_SELECTED_DATE',
};
